// @flow

import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

type Props = {
  percentage: {
    fold: number,
    call: number,
    check: number,
    raise: number,
  } | null,
  handleGetSimilar: (sort: 'fold' | 'call' | 'raise' | 'check') => void,
  firstItemIsHighlighted?: boolean,
}

const ProgressBarSimilar = ({ percentage, handleGetSimilar, firstItemIsHighlighted }: Props) => {
  const call = percentage?.call ? Math.round(percentage?.call) : null;
  const check = percentage?.check ? Math.round(percentage?.check) : null;
  const fold = percentage?.fold ? Math.round(percentage?.fold) : null;
  const raise = percentage?.raise ? Math.round(percentage?.raise) : null;
  const isResult = !call && !fold && !raise && !check;

  return (
    <div className={`${styles.wrapper} ${firstItemIsHighlighted ? styles.noBottomBorder : ''}`}>
      <div className={cn(
        styles.resultProgressBar,
        { [styles.resultProgressBarDisabled]: isResult },
      )}
      >
        {isResult ? '0%' : null}
        <button
          type="button"
          className={cn(styles.container, styles.fold)}
          style={{ width: `${fold || 0}%` }}
          onClick={() => handleGetSimilar('fold')}
        >
          {fold ? `${fold}%` : null}
        </button>
        <button
          type="button"
          className={cn(styles.container, styles.call)}
          style={{ width: `${call || 0}%` }}
          onClick={() => handleGetSimilar('call')}
        >
          {call ? `${call}%` : null}
        </button>
        <button
          type="button"
          className={cn(styles.container, styles.call)}
          style={{ width: `${check || 0}%` }}
          onClick={() => handleGetSimilar('check')}
        >
          {check ? `${check}%` : null}
        </button>
        <button
          type="button"
          className={cn(styles.container, styles.pot)}
          style={{ width: `${raise || 0}%` }}
          onClick={() => handleGetSimilar('raise')}
        >
          {raise ? `${raise}%` : null}
        </button>
      </div>
      <div className={styles.legendWrapper}>

        {fold ? (
          <div className={styles.item}>
            <div className={cn(styles.dot, styles.dotFold)} />
            <div className={styles.name}>
              Fold
            </div>
          </div>
        ) : null}
        {call ? (
          <div className={styles.item}>
            <div className={cn(styles.dot, styles.dotCall)} />
            <div className={styles.name}>
              Call
            </div>
          </div>
        ) : null}
        {check ? (
          <div className={styles.item}>
            <div className={cn(styles.dot, styles.dotCall)} />
            <div className={styles.name}>
              Check
            </div>
          </div>
        ) : null}
        {raise ? (
          <div className={styles.item}>
            <div className={cn(styles.dot, styles.dotPot)} />
            <div className={styles.name}>
              Raise
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProgressBarSimilar;
